import { Star } from "lucide-react";
import type React from "react";

interface RenderStarsProps {
    rating: number;
    size?: number;
}
const RenderStars: React.FC<RenderStarsProps> = ({rating, size=10}) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    
    for (let i = 0; i < 5; i++) {
    if (i < fullStars) {
        stars.push(
        <Star key={i} className=" fill-[#ff4e1d] text-[#ff4e1d]" size={size} />
        );
    } else if (i === fullStars && hasHalfStar) {
        stars.push(
        <div key={i} className="relative" style={{ width: size, height: size }}>
            <Star className="text-gray-300 absolute" size={size} />
            <div className="overflow-hidden absolute" style={{ width: `${rating / 5 * 100}%` }}>
            <Star className="fill-[#ff4e1d] text-[#ff4e1d]" size={size} />
            </div>
        </div>
        );
    } else {
        stars.push(
        <Star key={i} className="w-3 h-3 text-gray-300" />
        );
    }
    }
    return stars;
};

export default RenderStars;